import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { MetricValueLockLevel, MetricValueLockOperation, MetricValueLockScope, useAddFeedbackMutation, useBatchLockMetricAssignmentValuesMutation, useUpdateImpactGoalMutation } from '~/types/types';
import { renderMarkdown } from '~/functions/markdown';
import { getLocale } from '~/functions/translate';
export default /*#__PURE__*/_defineComponent({
  __name: 'outro',
  props: {
    ventureId: null,
    impactGoal: null
  },
  setup: function setup(__props) {
    var props = __props;
    var step = ref(1);
    var locale = getLocale();
    var route = useRoute();
    var router = useRouter();
    var thanks = computed(function () {
      return locale === 'en' ? 'Thank you for your feedback!' : 'Vielen Dank für Ihr Feedback!';
    });
    var metricAssignments = computed(function () {
      var _props$impactGoal, _props$impactGoal$imp;
      return (_props$impactGoal = props.impactGoal) === null || _props$impactGoal === void 0 ? void 0 : (_props$impactGoal$imp = _props$impactGoal.impacts) === null || _props$impactGoal$imp === void 0 ? void 0 : _props$impactGoal$imp.flatMap(function (impact) {
        return impact.metricAssignments;
      });
    });
    var _useUpdateImpactGoalM = useUpdateImpactGoalMutation(),
      updateImpactGoal = _useUpdateImpactGoalM.mutate;
    var _useBatchLockMetricAs = useBatchLockMetricAssignmentValuesMutation(),
      batchLockMetricAssignmentValues = _useBatchLockMetricAs.mutate;
    var toggleFreezeMetricAssignments = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(doFreeze) {
        var metricAssignmentIds;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              metricAssignmentIds = Array.from(new Set(metricAssignments.value.map(function (metricAssignment) {
                return metricAssignment.id;
              }).filter(function (id) {
                return id !== null && id !== undefined;
              })));
              if (metricAssignmentIds.length) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _context.next = 5;
              return batchLockMetricAssignmentValues({
                input: {
                  metricAssignmentIds: metricAssignmentIds,
                  operation: doFreeze ? MetricValueLockOperation.Freeze : MetricValueLockOperation.Unfreeze,
                  scope: MetricValueLockScope.Target,
                  lockingLevel: MetricValueLockLevel.Portfolio,
                  reason: doFreeze ? 'Impact goal submitted: targets locked by venture.' : 'Impact goal reopened: targets unlocked by venture.'
                }
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function toggleFreezeMetricAssignments(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var handleSubmit = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _props$impactGoal2, _props$impactGoal3;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (props !== null && props !== void 0 && (_props$impactGoal2 = props.impactGoal) !== null && _props$impactGoal2 !== void 0 && _props$impactGoal2.id) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.next = 4;
              return updateImpactGoal({
                input: {
                  id: props === null || props === void 0 ? void 0 : (_props$impactGoal3 = props.impactGoal) === null || _props$impactGoal3 === void 0 ? void 0 : _props$impactGoal3.id,
                  isEditable: false,
                  doUpdateSubmitDate: true
                }
              });
            case 4:
              _context2.next = 6;
              return toggleFreezeMetricAssignments(true);
            case 6:
              step.value = 2;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function handleSubmit() {
        return _ref2.apply(this, arguments);
      };
    }();
    var feedback = ref({
      title: 'Impact goal',
      rating: 0,
      description: '',
      url: route.fullPath
    });
    var _useAddFeedbackMutati = useAddFeedbackMutation(),
      addFeedback = _useAddFeedbackMutati.mutate;
    var submitFeedback = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return addFeedback({
                payload: feedback.value
              }).then(function () {
                window.$nuxt.$emit('userMsg', {
                  color: 'green',
                  message: thanks.value
                });
                feedback.value = {
                  title: 'Impact goal',
                  description: '',
                  rating: 0,
                  url: route.fullPath
                };
                router.push("/".concat(props.ventureId, "/impact"));
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function submitFeedback() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      step: step,
      locale: locale,
      route: route,
      router: router,
      thanks: thanks,
      metricAssignments: metricAssignments,
      updateImpactGoal: updateImpactGoal,
      batchLockMetricAssignmentValues: batchLockMetricAssignmentValues,
      toggleFreezeMetricAssignments: toggleFreezeMetricAssignments,
      handleSubmit: handleSubmit,
      feedback: feedback,
      addFeedback: addFeedback,
      submitFeedback: submitFeedback,
      renderMarkdown: renderMarkdown
    };
  }
});